import clsx from 'clsx';
import React, {HtmlHTMLAttributes, MouseEventHandler} from 'react';
import Tooltip from '../tooltip/tooltip';
import * as styles from './buttonIcon.module.css';

type IButtonIconProps = HtmlHTMLAttributes<HTMLButtonElement> & {
    className?: string,
    tooltipText: string,
    icon: React.JSXElementConstructor<React.SVGProps<SVGSVGElement>>,
    onClick?: (e: React.MouseEvent<Element>) => void,
    isWhite?: boolean,
    isClose?: boolean,
    disabled?: boolean,
    active?: boolean,
    isButton?: boolean,
    href?: string,
    target?: string,
    sidePadding?: number,
    color?: string,
};

const ButtonIcon = ({
    className,
    tooltipText,
    icon: Icon,
    onClick = () => {},
    isWhite = false,
    isClose = false,
    disabled = false,
    isButton = true,
    sidePadding = 1,
    active,
    href,
    target = '_self',
    color,
    ...props
}: IButtonIconProps) => {
    const handleButtonClick: MouseEventHandler = e => {
        if (disabled) {
            return;
        }

        onClick(e);
    };

    const link = disabled ? '#' : href;

    const LinkIcon = () => (
        <>
            {disabled && (
                <span
                    className={clsx(
                        styles.button,
                        styles.disabled,
                        className,
                    )}
                    style={{
                        '--sidePadding': sidePadding,
                    } as React.CSSProperties}
                    onClick={handleButtonClick}
                >
                    {Icon && (<Icon/>)}
                </span>
            )}
            {!disabled && (
                <a
                    className={clsx(styles.button, className)}
                    style={{
                        '--sidePadding': sidePadding,
                    } as React.CSSProperties}
                    href={link}
                    target={target}
                    onClick={handleButtonClick}
                    {...props}
                >
                    {Icon && (<Icon/>)}
                </a>
            )}
        </>
    );

    return (
        <>
            {isButton && (
                <Tooltip text={tooltipText}>
                    <button
                        className={clsx(
                            styles.button,
                            isWhite && styles.white,
                            isClose && styles.close,
                            active && styles.active,
                            className,
                        )}
                        style={{
                            '--sidePadding': sidePadding,
                            color,
                        } as React.CSSProperties}
                        onClick={handleButtonClick}
                        disabled={disabled}
                        {...props}
                    >
                        {Icon && (
                            <Icon/>
                        )}
                    </button>
                </Tooltip>
            )}
            {!isButton && (
                <Tooltip text={tooltipText}>
                    <LinkIcon/>
                </Tooltip>
            )}
        </>

    );
};

export default ButtonIcon;
